import { createContext, useContext } from 'react';
import {IConsulenteItem, IUserItem} from "../../types/user";

type AuthContextType = {
  user?: IUserItem | IConsulenteItem;
  checkUserSession: () => Promise<IUserItem |IConsulenteItem | undefined>;
  loading: boolean;
  authenticated: boolean;
  unauthenticated: boolean;
};

export const AuthContext = createContext<AuthContextType | null>(null);
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
}
